import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { iconNameIconMap, PermissionIconName } from '../../../constants/permissionIconNames';

const IconDiffField = ({
  label,
  oldIconName,
  newIconName,
}: {
  label: string;
  oldIconName?: string;
  newIconName?: string;
}) => {
  const OldIcon = oldIconName ? iconNameIconMap[oldIconName as PermissionIconName] : null;
  const NewIcon = newIconName ? iconNameIconMap[newIconName as PermissionIconName] : null;

  return (
    <Grid
      size={{
        xs: 12,
        md: 6,
        xl: 3,
      }}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="mediumTitle">{label}</Typography>
        <Box display="flex" flexDirection="row" alignItems="center">
          {OldIcon ? <OldIcon fontSize="small" color="error" /> : oldIconName}
          <ArrowForwardIcon sx={{ marginX: 2 }} fontSize="small" />
          {NewIcon ? <NewIcon fontSize="small" color="secondary" /> : newIconName}
        </Box>
      </Box>
    </Grid>
  );
};

export default IconDiffField;
